module.exports = __webpack_public_path__ + "images/cc8e5eed3f1d505374de57ec3d80e058d0.jpg";